// *************** code with data dynamic ****************
import axios from "axios";
import authHeader from "./auth-header";
import API_BASE_URL2 from "../config/apiConfig";
import API_BASE_ from "../config/apiConfig";
import React, { useState, useEffect } from "react";

const API_BASE = `${API_BASE_}`;

// 🔗 Endpoints dérivés
const API_BASE_URL = `${API_BASE}/courses/`; // Pour compatibilité avec le code existant
const API_BASE_URL_COURSES = `${API_BASE}/courses/`;
const API_BASE_URL_SUBJECTS = `${API_BASE}/courses/subjects/`; // ✅ Correct

const API_BASE_URL_QUIZZES = `${API_BASE}/quizzes/`;
const API_BASE_TRAINING_EXERCISES = `${API_BASE}/training-exercises/`;

const API_BASE_Note_Finale = `${API_BASE}/note-finale/`;
const API_Progresse = `${API_BASE}/progress/`;
const API_BASE_URL_CERTIFICATS = `${API_BASE}/certificats/`;
const API_BASE_URL_Badges = `${API_BASE}/badges/`;

const API_TOTAL_POURCENTAGE = `${API_BASE}/pourcentage/`;
const paymentApi = `${API_BASE}/payment`;

const RESOURCE = `${API_BASE}/plans`;
const SALES_REQUESTS = `${API_BASE}/sales-requests`;
const NEWS_ENDPOINT = `${API_BASE}/news`;
const INSTRUCTOR_REQUESTS = `${API_BASE}/instructor-requests`;

const API_BASE_PURCHASES = `${API_BASE}/purchases`;
const API_BASE_USERS = `${API_BASE}/admin/users`;
const API_BASE_CATEGORIES = `${API_BASE}/categories`;
const API_BASE_SUBCATEGORIES = `${API_BASE}/subcategories`;

// Méthode pour uploader une image sur le serveur
const uploadImage = async (image) => {
    if (!image) {
        alert("Veuillez sélectionner une image.");
        throw new Error("Aucune image fournie.");
    }

    const formData = new FormData();
    formData.append("file", image);

    try {
        console.log("Envoi de l'image au backend : ", image);
        const response = await axios.post(API_BASE_URL + "upload-image", formData, {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data",
            },
        });
        console.log("Réponse de l'upload de l'image :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de l'image :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'upload de l'image.";
        throw new Error(errorMessage);
    }
};

// Méthode pour créer un cours avec les données et l'image
const createCourse = async (courseData, file) => {
    if (!courseData || !file) {
        alert("Données ou fichier manquants pour créer le cours.");
        throw new Error("Les données du cours ou le fichier ne sont pas fournis.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("course", JSON.stringify(courseData));

    try {
        console.log("Envoi des données du cours au backend :", courseData);
        const response = await axios.post(API_BASE_URL + "create-course", formData, { headers: authHeader() });
        console.log("Réponse de la création du cours :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création du cours :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de la création du cours.";
        throw new Error(errorMessage);
    }
};

const updateCourse = async (id, courseData, file) => {
    if (!id || !courseData) {
        throw new Error("L'ID du cours ou les données sont manquants.");
    }

    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }

    // Convertir imageUrl en image
    const cleanCourseData = { ...courseData };
    if (cleanCourseData.imageUrl) {
        cleanCourseData.image = cleanCourseData.imageUrl;
        delete cleanCourseData.imageUrl;
    }
    formData.append("course", JSON.stringify(cleanCourseData));

    try {
        const response = await axios.put(
            `${API_BASE_URL}update-course/${id}`,
            formData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du cours :", error.response || error.message);
        throw new Error(error.response?.data || "Erreur lors de la mise à jour du cours.");
    }
};


// const getCoursesByModerator = async (moderatorId) => {
//     const headers = authHeader();
//     console.log("🔑 Headers envoyés :", headers);

//     try {
//         // ✅ NOUVEAU ENDPOINT OPTIMISÉ qui retourne des DTOs
//         const response = await axios.get(`${API_BASE_URL}user?userId=${moderatorId}`, {
//             headers: headers,
//         });

//         console.log("✅ Cours reçus (optimisés):", response.data.length);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur détaillée :", error.response?.data);
//         throw error;
//     }
// };

const getCoursesByModerator = async (moderatorId) => {
    const headers = authHeader();
    console.log("🔑 Headers envoyés :", headers);

    try {
        // ✅ ENDPOINT QUI RETOURNE TOUS LES COURS (approuvés + en attente)
        const response = await axios.get(`${API_BASE_URL}moderator/${moderatorId}`, {
            headers: headers,
        });

        console.log("✅ Cours reçus (incluant en attente):", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur détaillée :", error.response?.data);
        throw error;
    }
};

const addSubjectToCourse = async (courseId, subjectData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/subjects`,
            subjectData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du sujet :", error);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'ajout du sujet.";
        throw new Error(errorMessage);
    }
};

const getSubjectsByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/subjects`, {
            headers: authHeader()
        });

        return response.data.map(subject => ({
            id: subject.id,
            group_name: subject.group_name,
            title: subject.title,
            subTitle: subject.subTitle,
            content: subject.content,
            courseId: subject.courseId
        }));
    } catch (error) {
        console.error("Erreur lors de la récupération des sujets :", error);
        throw error;
    }
};

const getCourseDetails = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
        throw error;
    }
};

const getUserPurchases = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}purchases`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des achats :", error);
        throw error;
    }
};

const getCategories = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des catégories :", error);
        throw error;
    }
};

const getSubcategories = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories/${categoryId}/subcategories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des sous-catégories :", error);
        throw error;
    }
};

const addComment = async (subjectId, content) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/comments/${subjectId}`,
            { content },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du commentaire :", error);
        throw error;
    }
};

const updateSubject = (subjectId, updatedData) => {
    return axios.put(`${API_BASE_URL}subjects/${subjectId}`, updatedData, { headers: authHeader() });
};

const deleteSubject = async (subjectId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}subjects/${subjectId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression du sujet :", error);
        throw error;
    }
};

const getQuestionsByQuiz = async (quizId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/${quizId}/questions`, {
            headers: authHeader(),
        });
        console.log("📦 Contenu brut reçu pour les questions :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des questions :", error);
        throw error;
    }
};

const submitQuizAnswers = async (quizId, answers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/submit`,
            answers,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la soumission des réponses :", error);
        throw error;
    }
};

const addQuizWithQuestions = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes_old`,
            quizData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz avec questions :", error);
        throw error;
    }
};

const deleteQuiz = async (quizId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/${quizId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression du quiz :", error);
        throw error;
    }
};

const getQuizzesBySubject = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}quizzes/subject/${subjectId}`, { headers: authHeader() });
    return response.data;
};

const addQuizToSubject = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes`,
            {
                ...quizData,
                course: { id: subjectId },
                linkType: 'subject',
                linkId: subjectId
            },
            { headers: authHeader() }
        );

        console.log("Quiz ajouté avec succès :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz :", error.response?.data || error.message);
        throw error;
    }
};

const addQuestionToQuiz = async (quizId, questionData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/questions`,
            questionData,
            { headers: authHeader() }
        );

        if (!response.data || !response.data.id) {
            throw new Error("Erreur : ID de la question non retourné !");
        }

        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la question :", error);
        throw error;
    }
};

const addAnswerToQuestion = async (questionId, answerData) => {
    if (!questionId) {
        throw new Error("Erreur : ID de la question manquant !");
    }

    const response = await axios.post(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, answerData, { headers: authHeader() });
    return response.data;
};

const getAnswersByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des réponses :", error);
        throw error;
    }
};

const updateQuestionExplanation = async (questionId, explanation) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-explanation`,
            { explanation },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'explication :", error);
        throw error;
    }
};

const getQuestionById = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la question :", error);
        throw error;
    }
};

const updateQuestion = async (questionId, questionData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/questions/${questionId}`, questionData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la question :", error);
        throw error;
    }
};

const updateAnswer = async (answerId, answerData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/answers/${answerId}`, answerData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la réponse :", error);
        throw error;
    }
};

const deleteQuestion = async (questionId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la question :", error);
        throw error;
    }
};

const deleteAnswer = async (answerId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/answers/${answerId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la réponse :", error);
        throw error;
    }
};

const deleteCourse = async (courseId) => {
    try {
        await axios.delete(`${API_BASE_URL}${courseId}`, { headers: authHeader() });
    } catch (error) {
        console.error("Erreur lors de la suppression du cours :", error);
        throw error;
    }
};

const updateQuiz = async (quizId, quizData) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/${quizId}`,
            {
                title: quizData.title,
                introductionText: quizData.introductionText,  // ✅ AJOUTER CETTE LIGNE
                attemptOnce: quizData.attemptOnce,
                elementType: quizData.elementType,
                referenceElementId: quizData.referenceElementId,
                positioning: quizData.positioning,
                progressPercentage: quizData.progressPercentage
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du quiz :", error);
        throw error;
    }
};

const updateQuizProgress = async (quizId, isChecked, progressPercentage) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/${quizId}/updateProgress`, {
            isChecked,
            progressPercentage,
        }, { headers: authHeader() });

        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du quiz :", error);
        throw error;
    }
};

const updateCorrectAnswers = async (questionId, data) => {
    try {
        console.log("📡 Envoi au backend :", questionId, data);

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/update-correct-answers/${questionId}`,
            data,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur API :", error.response?.data || error.message);
        throw error;
    }
};

const updateAnswersOrder = async (questionId, orderedAnswerIds) => {
    try {
        console.log("📡 Envoi au backend pour mise à jour de l'ordre :", orderedAnswerIds);

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-order`,
            orderedAnswerIds,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de l'ordre des réponses :", error.response?.data || error.message);
        throw error;
    }
};

const uploadAttachmentToCourse = async (courseId, file) => {
    if (!file) {
        throw new Error("Aucun fichier sélectionné pour l'upload.");
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/attachments`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de la pièce jointe :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de l'upload.");
    }
};

const getAttachmentsByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/attachments`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des pièces jointes :", error);
        throw error;
    }
};

const addResourceToCourse = async (courseId, resourceData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/resources`,
            resourceData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la ressource :", error);
        throw error;
    }
};

const getResourcesByCourse = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}${courseId}/resources`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des ressources :", error);
        throw error;
    }
};

// const getResourcesBySubject = async (subjectId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL_COURSES}${subjectId}/resources`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des ressources par sujet :", error);
//         throw error;
//     }
// };

const getQuizzesByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/quizzes`, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des quizzes du cours :", error);
        throw error;
    }
};

const getEvaluationByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/evaluation`, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des quizzes du cours :", error);
        throw error;
    }
};

const addQuizToCourse = async (courseId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/courses/${courseId}/quizzes`,
            {
                ...quizData,
                linkType: 'course',
                linkId: courseId
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz au cours :", error.response?.data || error.message);
        throw error;
    }
};

const addEvaluationToCourse = async (courseId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/courses/${courseId}/evaluation`,
            {
                ...quizData,
                linkType: 'evaluation',
                linkId: courseId
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du l'évaluation au cours :", error.response?.data || error.message);
        throw error;
    }
};

const uploadAttachmentToSubject = async (subjectId, file) => {
    if (!file) {
        throw new Error("Aucun fichier sélectionné pour l'upload.");
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(
            `${API_BASE_URL}subjects/${subjectId}/attachments`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de la pièce jointe au sujet :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de l'upload.");
    }
};

const addResourceToSubject = async (subjectId, resourceData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}subjects/${subjectId}/resources`,
            resourceData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la ressource au sujet :", error);
        throw error;
    }
};

const getAttachmentsBySubject = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}subjects/${subjectId}/attachments`, {
        headers: authHeader(),
    });
    return response.data;
};

const uploadTrainingExercise = async (courseId, file, title, instructionsText) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("instructionsText", instructionsText);

    try {
        const response = await axios.post(
            `${API_BASE_TRAINING_EXERCISES}course/${courseId}`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création de l'exercice :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de la création.");
    }
};

const getTrainingExercisesByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const getTrainingExercisesByCourseByTriningId = async (traiiningId) => {
    try {
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}training/${traiiningId}/responses`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const getTrainingExercisesByCourseByTriningIdAndUserId = async (trainingId, userId = null) => {
    try {
        let url = `${API_BASE_TRAINING_EXERCISES}training/${trainingId}/responses_for_user`;

        if (userId) {
            url += `?userId=${userId}`;
        }

        const response = await axios.get(url, {
            headers: authHeader()
        });

        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const getTrainingExercisesByCourseByUser = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}/responses-with-users`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const updateTrainingGrade = async (responseId, grade) => {
    try {
        const response = await axios.put(
            `${API_BASE_TRAINING_EXERCISES}responses/${responseId}/grade`,
            null,
            {
                params: { grade },
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la note :", error);
        throw error;
    }
};

const deleteTrainingExercise = async (exerciseId) => {
    return axios.delete(`${API_BASE_TRAINING_EXERCISES}${exerciseId}`, {
        headers: authHeader()
    });
};

const updateExercise = async (id, title, instructionsText) => {
    try {
        const response = await axios.put(`${API_BASE_TRAINING_EXERCISES}${id}`, null, {
            params: { title, instructionsText },
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'exercice :", error);
        throw error;
    }
};

const getTrainingsByCourse = async (courseId) => {
    return axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}`, { headers: authHeader() });
}

const uploadStudentTrainingResponse = async (exerciseId, userId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", userId);

    try {
        const response = await axios.post(
            `${API_BASE_TRAINING_EXERCISES}${exerciseId}/upload-response-user`,
            formData,
            {
                headers: {
                    ...authHeader(),
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload du fichier étudiant :", error.response || error.message);
        throw error;
    }
};

const getQuizById = async (quizId) => {
    return axios.get(`${API_BASE_URL_QUIZZES}${quizId}`, {
        headers: authHeader(),
    });
};

const getMatchingPairsByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/matching-pairs`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des paires MATCHING :", error);
        throw error;
    }
};

const addMatchingPairToQuestion = async (questionId, pair) => {
    return axios.post(`${API_BASE_URL}quizzes/questions/${questionId}/matching-pairs`, pair, {
        headers: authHeader()
    });
}

export const getSubjectById = async (subjectId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_SUBJECTS}${subjectId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération du sujet par ID :", error);
        throw error;
    }
};

const generateBadge = async (student, course, score, threshold) => {
    const response = await axios.get(
        `${API_BASE}/badges/generate`,
        {
            params: { student, course, score, threshold },
            headers: {
                ...authHeader(),
                "Accept": "application/pdf"
            },
            responseType: 'blob'
        }
    );

    return new Blob([response.data], { type: "application/pdf" });
};

const getThreshold = async (courseId) => {
    const response = await axios.get(`${API_BASE}/badges/threshold/${courseId}`, {
        headers: authHeader()
    });
    return response.data;
};

const updateThreshold = async (courseId, threshold) => {
    return axios.put(
        `${API_BASE}/badges/threshold/${courseId}/${threshold}`,
        null,
        {
            headers: authHeader()
        }
    );
};

const getBadgeUrl = async (student, courseId, courseTitle, score, threshold) => {
    try {
        const response = await axios.get(`${API_BASE}/badges/generate`, {
            params: {
                student,
                courseId,
                course: courseTitle,
                score,
                threshold
            },
            headers: authHeader()
        });

        if (response.status === 200 && response.data?.startsWith("http")) {
            return response.data;
        }

        return null;
    } catch (error) {
        if (error.response?.status === 404) {
            console.log("ℹ️ Aucun badge encore généré.");
        } else {
            console.error("❌ Erreur API getBadgeUrl:", error);
        }
        return null;
    }
};

const getAllUsernames = async () => {
    const response = await axios.get(`${API_BASE}/auth/users`, {
        headers: authHeader()
    });
    return response.data;
};

const getBadgesByCourse = async (courseId) => {
    const response = await axios.get(`${API_BASE}/badges/course/${courseId}`, {
        headers: authHeader(),
    });
    return response.data;
};

const deleteBadge = async (badgeId) => {
    return axios.delete(`${API_BASE}/badges/${badgeId}`, {
        headers: authHeader(),
    });
};

const getCourseStructure = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/structure`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la structure du cours :", error);
        throw error;
    }
};

const getquizzes_of_cours = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/quizzes_of_cours`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la structure du cours :", error);
        throw error;
    }
};

const uploadTrainingExerciseWithPositioning = async (courseId, meta, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("exercise", JSON.stringify(meta));

    try {
        const response = await axios.post(
            `${API_BASE_TRAINING_EXERCISES}course/${courseId}/positioned`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout positionné de l'exercice :", error.response || error.message);
        throw error;
    }
};

const getCourseElements = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/elements`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des éléments du cours :", error);
        throw error;
    }
};

const Getgroupnames = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_SUBJECTS}${courseId}/group-names`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des éléments du cours :", error);
        throw error;
    }
};

const deleteTrainingBloc = async (trainingId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_TRAINING_EXERCISES}delete/${trainingId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression du bloc d'entraînement :", error);
        throw error;
    }
};

export const updateTrainingExerciseWithPositioning = async (id, payload, file) => {
    const formData = new FormData();

    payload.referenceElementId = Number(payload.referenceElementId);

    formData.append("exercise", JSON.stringify(payload));
    if (file) {
        formData.append("file", file);
    }

    return axios.put(
        `${API_BASE_TRAINING_EXERCISES}training/${id}/positioned`,
        formData,
        {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

const submitQuizResult = async ({ userId, quizId, scoreObtained, scoreTotal, answers }) => {
    try {
        const response = await axios.post(
            `${API_BASE}/courses/user-quiz-results`,
            { userId, quizId, scoreObtained, scoreTotal, answers },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la soumission du résultat du quiz :", error);
        throw error;
    }
};

const getQuizReviewResults = async (userId, quizId) => {
    try {
        const response = await axios.get(
            `${API_BASE}/courses/user-quiz-results/review`,
            {
                params: { userId, quizId },
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la revue des résultats :", error);
        throw error;
    }
};

const CalculeNoteFinale = async (courseId, userId) => {
    try {
        const url = `${API_BASE_Note_Finale}${courseId}/${userId}`;
        console.log("🌐 [SERVICE] URL API appelée :", url);

        const response = await axios.get(url, {
            headers: authHeader(),
        });

        console.log("✅ [SERVICE] Réponse API reçue :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ [SERVICE] Erreur lors de la récupération de la note finale :", error);
        throw error;
    }
};

const GetNotAttemptedItems = async (courseId, userId) => {
    try {
        const url = `${API_BASE_Note_Finale}not-attempted/${courseId}/${userId}`;
        console.log("🌐 [SERVICE] URL API appelée :", url);

        const response = await axios.get(url, {
            headers: authHeader(),
        });

        console.log("✅ [SERVICE] Réponse API reçue :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ [SERVICE] Erreur lors de la récupération des éléments non tentés :", error);
        throw error;
    }
};

const CalculePrgresseByType = async (type, courseId, userId, quizId = null) => {
    try {
        let url = `${API_Progresse}?type=${type}&courseId=${courseId}&userId=${userId}`;
        if (quizId !== null) {
            url += `&quizId=${quizId}`;
        }

        const response = await axios.get(url, {
            headers: authHeader(),
        });

        return response.data;
    } catch (error) {
        console.error("❌ [SERVICE] Erreur lors de la récupération du progrès :", error);
        throw error;
    }
};

export const getAttemptOnceByCourse = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE}/courses/quizzes/courses/${courseId}/attempt-once`,
            {
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération de attemptOnce :", error);
        throw error;
    }
};

const uploadImageCertificat = async (file, courseId, formateur, editorContent, settings) => {
    if (!file) throw new Error("Aucune image fournie.");
    if (!courseId) throw new Error("CourseId manquant.");
    if (!formateur) throw new Error("Nom du formateur manquant.");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseId", courseId);
    formData.append("formateur", formateur);
    formData.append("template_html", editorContent || "");
    formData.append("template_settings", JSON.stringify(settings || {}));

    if (settings?.threshold !== undefined) {
        formData.append("threshold", settings.threshold);
    }
    try {
        const response = await axios.post(
            API_BASE_URL_CERTIFICATS + "upload",
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        console.log("✅ Réponse brute :", response.data);
        return response.data?.url || null;

    } catch (error) {
        console.error("Erreur lors de l'upload du certificat :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de l'upload du certificat.");
    }
};

const getGeneratedCertificat = async (courseId, userId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_CERTIFICATS}generate`,
            {
                headers: authHeader(),
                params: { courseId, userId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la génération du certificat :", error.response || error.message);
        throw new Error("Impossible de générer le certificat.");
    }
};

const getLastThresholdCertificat = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_CERTIFICATS}last-threshold/${courseId}`,
            {
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération du threshold :", error.response || error.message);
        throw new Error("Impossible de récupérer le threshold.");
    }
};

const getTotalPourcentage = async (courseId) => {
    try {
        const response = await axios.get(`${API_TOTAL_POURCENTAGE}${courseId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des pourcentages:", error);
        throw error;
    }
};

const getLastThresholdbadge = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_Badges}last-threshold/${courseId}`,
            {
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération du threshold :", error.response || error.message);
        throw new Error("Impossible de récupérer le threshold.");
    }
};

const createPaymentIntent = async (paymentData) => {
    const url = `${paymentApi}/create-auto`;

    const requestBody = {
        userId: paymentData.userId,
        courseId: paymentData.courseId,
        currency: paymentData.currency || "usd"
    };

    console.log('📤 Création PaymentIntent:', requestBody);
    const res = await axios.post(url, requestBody, { headers: authHeader() });
    console.log('📥 PaymentIntent créé:', res.data);

    return res.data;
};

const confirmPayment = async (paymentIntentId) => {
    console.warn('⚠️ confirmPayment() ne devrait plus être utilisé avec Stripe Elements');
    const url = `${paymentApi}/confirm?paymentIntentId=${encodeURIComponent(paymentIntentId)}`;
    const res = await axios.post(url, null, { headers: authHeader() });
    return res.data;
};

const getPaymentStatus = async (paymentIntentId) => {
    const url = `${paymentApi}/status?paymentIntentId=${encodeURIComponent(paymentIntentId)}`;
    const res = await axios.get(url, { headers: authHeader() });
    console.log('📊 Statut du paiement:', res.data);
    return res.data;
};

const getMyPurchases = async (userId) => {
    const url = `${paymentApi}/my-purchases?userId=${userId}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
};

const getMyPurchases2 = async (userId) => {
    const url = `${API_BASE_URL}my-purchases?userId=${userId}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
};

const getAllCourses = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}`, {
            headers: authHeader(),
        });
        console.log("📡 Tous les cours récupérés:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération de tous les cours :", error);
        throw error;
    }
};

const getAllCoursesOptimized = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}summary`, {
            headers: authHeader(),
        });
        console.log("📡 Cours optimisés récupérés:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours optimisés :", error);
        throw error;
    }
};

const checkCourseOwnership = async (userId, courseId) => {
    try {
        const url = `${paymentApi}/check-purchase?userId=${userId}&courseId=${courseId}`;
        const res = await axios.get(url, { headers: authHeader() });
        return res.data;
    } catch (error) {
        console.error("❌ Erreur lors de la vérification de propriété :", error);
        return { hasPurchased: false };
    }
};

const createPaymentIntentLegacy = async (amount) => {
    const url = `${paymentApi}/create?amount=${amount}`;
    const res = await axios.post(url, null, { headers: authHeader() });
    return res.data;
};

const getCourseById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération du cours :", error);
        throw error;
    }
};

const getCoursesByUserId = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}/user/${userId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours de l'utilisateur :", error);
        throw error;
    }
};

const createPayPalPayment = async (userId, courseId, currency = 'usd') => {
    try {
        const response = await axios.post(`${API_BASE}/paypal/create-payment`, {
            userId,
            courseId,
            currency
        }, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Erreur création paiement PayPal:', error);
        throw error;
    }
};

const executePayPalPayment = async (paymentId, payerId) => {
    try {
        const response = await axios.get(`${API_BASE}/paypal/execute-payment`, {
            params: { paymentId, PayerID: payerId },
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error('Erreur exécution paiement PayPal:', error);
        throw error;
    }
};

const sanitizeDescriptor = (s) =>
    (s || 'COURSE')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^A-Za-z0-9 ]/g, '')
        .trim().toUpperCase()
        .slice(0, 20);

const createMonerisTicket = async ({ course, amount, user }) => {
    const payload = {
        amount: Number(amount || course?.latest_price || course?.price || 0),
        currency: 'CAD',
        orderId: `COURSE-${course?.id}-${Date.now()}`,
        description: sanitizeDescriptor(course?.title),
        successUrl: `${window.location.origin}/payments/moneris/success`,
        cancelUrl: `${window.location.origin}/payments/moneris/cancel`,
        contactInfo: {
            firstName: user?.firstName || user?.username || 'User',
            lastName: user?.lastName || 'N/A',
            email: user?.email || '',
            phone: user?.phone || ''
        }
    };

    const { data } = await axios.post(
        `${API_BASE}/payments/moneris/create-ticket`,
        payload,
        { headers: { ...authHeader(), 'Content-Type': 'application/json' }, withCredentials: true }
    );
    return data;
};

const monerisVerifyTicket = async (ticketId) => {
    const url = `${API_BASE}/payments/moneris/verify/${encodeURIComponent(ticketId)}`;
    const { data } = await axios.get(url, { headers: authHeader() });
    return data;
};

const getAllPlans = async () => {
    const { data } = await axios.get(RESOURCE, {
        headers: authHeader(),
        withCredentials: true
    });
    return data;
};

const getPlanById = async (id) => {
    const { data } = await axios.get(`${RESOURCE}/${id}`, { headers: authHeader() });
    return data;
};

const createPlan = async (payload) => {
    const { data } = await axios.post(RESOURCE, payload, {
        headers: { ...authHeader(), "Content-Type": "application/json" }
    });
    return data;
};

const updatePlan = async (id, payload) => {
    const { data } = await axios.put(`${RESOURCE}/${id}`, payload, {
        headers: { ...authHeader(), "Content-Type": "application/json" }
    });
    return data;
};

const deletePlan = async (id) => {
    const { data } = await axios.delete(`${RESOURCE}/${id}`, { headers: authHeader() });
    return data;
};

const createSalesRequest = async (payload) => {
    const { data } = await axios.post(SALES_REQUESTS, payload, {
        headers: { 'Content-Type': 'application/json', ...authHeader() }
    });
    return data;
};

const getCourseSummary = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}summary`, {
            headers: authHeader(),
        });
        console.log("📡 Résumé des cours récupéré:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération du résumé des cours :", error);
        throw error;
    }
};

const getCoursesByCategory = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}/category/${categoryId}`, {
            headers: authHeader(),
        });
        console.log(`📡 Cours de la catégorie ${categoryId} récupérés:`, response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours par catégorie :", error);
        throw error;
    }
};

const getCoursesWithPagination = async (page = 0, size = 20) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}/paginated?page=${page}&size=${size}`, {
            headers: authHeader(),
        });
        console.log(`📡 Cours paginés (page ${page}) récupérés:`, response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours paginés :", error);
        throw error;
    }
};

const getAllNews = async () => {
    try {
        const response = await axios.get(NEWS_ENDPOINT, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des actualités :", error);
        throw error;
    }
};

const getLatestNews = async (limit = 6) => {
    try {
        const response = await axios.get(`${NEWS_ENDPOINT}/latest?limit=${limit}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des dernières actualités :", error);
        throw error;
    }
};

const getNewsById = async (id) => {
    try {
        const response = await axios.get(`${NEWS_ENDPOINT}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération de l'actualité :", error);
        throw error;
    }
};

const createNews = async (newsData) => {
    try {
        const response = await axios.post(NEWS_ENDPOINT, newsData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la création de l'actualité :", error);
        throw error;
    }
};

const updateNews = async (id, newsData) => {
    try {
        const response = await axios.put(`${NEWS_ENDPOINT}/${id}`, newsData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de l'actualité :", error);
        throw error;
    }
};

const deleteNews = async (id) => {
    try {
        const response = await axios.delete(`${NEWS_ENDPOINT}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression de l'actualité :", error);
        throw error;
    }
};

const getSalesRequests = async () => {
    try {
        const { data } = await axios.get(SALES_REQUESTS, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des demandes commerciales:", error);
        throw error;
    }
};

const updateSalesRequestStatus = async (id, status) => {
    try {
        const { data } = await axios.patch(`${SALES_REQUESTS}/${id}/status`,
            { status },
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json"
                },
                withCredentials: true
            }
        );
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour du statut:", error);
        throw error;
    }
};

const updateSalesRequest = async (id, payload) => {
    try {
        const { data } = await axios.put(`${SALES_REQUESTS}/${id}`,
            payload,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json"
                },
                withCredentials: true
            }
        );
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la demande:", error);
        throw error;
    }
};

const deleteSalesRequest = async (id) => {
    try {
        await axios.delete(`${SALES_REQUESTS}/${id}`, {
            headers: authHeader(),
            withCredentials: true
        });
        return true;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression de la demande:", error);
        throw error;
    }
};

const getSalesRequestById = async (id) => {
    try {
        const { data } = await axios.get(`${SALES_REQUESTS}/${id}`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération de la demande:", error);
        throw error;
    }
};

const createInstructorRequest = async (instructorData) => {
    try {
        const { data } = await axios.post(INSTRUCTOR_REQUESTS, instructorData, {
            headers: {
                ...authHeader(),
                "Content-Type": "application/json"
            },
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la candidature d'instructeur:", error);
        throw error;
    }
};

const getAllInstructorRequests = async () => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des candidatures:", error);
        throw error;
    }
};

const getInstructorRequestsWithPagination = async (page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc') => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/paginated`, {
            params: { page, size, sortBy, sortDir },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération paginée:", error);
        throw error;
    }
};

const getInstructorRequestsByStatus = async (status) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/status/${status}`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération par statut:", error);
        throw error;
    }
};

const getInstructorRequestById = async (id) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/${id}`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération de la candidature:", error);
        throw error;
    }
};

const updateInstructorStatus = async (id, status) => {
    try {
        const { data } = await axios.put(`${INSTRUCTOR_REQUESTS}/admin/${id}/simple-status`,
            { status },
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json"
                },
                withCredentials: true
            }
        );
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour du statut:", error);
        throw error;
    }
};

const updateInstructorStatusWithNotes = async (id, statusUpdate) => {
    try {
        const { data } = await axios.put(`${INSTRUCTOR_REQUESTS}/admin/${id}/status`,
            statusUpdate,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json"
                },
                withCredentials: true
            }
        );
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour du statut avec notes:", error);
        throw error;
    }
};

const deleteInstructorRequest = async (id) => {
    try {
        const { data } = await axios.delete(`${INSTRUCTOR_REQUESTS}/admin/${id}`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression:", error);
        throw error;
    }
};

const searchInstructorByEmail = async (email) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/search/email`, {
            params: { email },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la recherche par email:", error);
        throw error;
    }
};

const searchInstructorBySubject = async (subject) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/search/subject`, {
            params: { subject },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la recherche par sujet:", error);
        throw error;
    }
};

const searchInstructorByName = async (name) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/search/name`, {
            params: { name },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la recherche par nom:", error);
        throw error;
    }
};

const advancedInstructorSearch = async (filters, page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc') => {
    try {
        const params = {
            page,
            size,
            sortBy,
            sortDir,
            ...filters
        };

        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/search/advanced`, {
            params,
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la recherche avancée:", error);
        throw error;
    }
};

const getInstructorStats = async () => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/stats`, {
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des statistiques:", error);
        throw error;
    }
};

const getRecentInstructorRequests = async (days = 30) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/recent`, {
            params: { days },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des demandes récentes:", error);
        throw error;
    }
};

const getOverdueInstructorRequests = async (days = 7) => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/admin/overdue`, {
            params: { days },
            headers: authHeader(),
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des demandes en retard:", error);
        throw error;
    }
};

const getAvailableInstructorStatuses = async () => {
    try {
        const { data } = await axios.get(`${INSTRUCTOR_REQUESTS}/statuses`, {
            withCredentials: true
        });
        return data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des statuts:", error);
        throw error;
    }
};

const getAllCoursesForAdmin = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}all-for-admin`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours admin:", error);
        throw error;
    }
};

const getPendingCourses = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}pending-approval`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des cours en attente:", error);
        throw error;
    }
};

const approveCourse = async (courseId, latestPrice, beforePrice, accessTime) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}approve/${courseId}`,
            null,
            {
                params: { latestPrice, beforePrice, accessTime },
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de l'approbation du cours:", error);
        throw error;
    }
};

const rejectCourse = async (courseId) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}reject/${courseId}`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du rejet du cours:", error);
        throw error;
    }
};

const verifyAndProcessMonerisPayment = async (ticketId, userId, courseId) => {
    try {
        const response = await axios.post(
            `${API_BASE}/payments/moneris/verify-and-process`,
            {
                ticketId: ticketId,
                userId: parseInt(userId),
                courseId: courseId
            },
            {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la vérification du paiement Moneris:", error);
        throw error;
    }
};

const getAllPurchases = async () => {
    try {
        const response = await axios.get(`${API_BASE_PURCHASES}/all`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des paiements:", error);
        throw error;
    }
};

const getPurchaseStats = async () => {
    try {
        const response = await axios.get(`${API_BASE_PURCHASES}/stats`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des statistiques:", error);
        throw error;
    }
};

const searchPurchases = async (filters) => {
    try {
        const params = new URLSearchParams();
        if (filters.status) params.append('status', filters.status);
        if (filters.userId) params.append('userId', filters.userId);
        if (filters.courseId) params.append('courseId', filters.courseId);
        if (filters.startDate) params.append('startDate', filters.startDate);
        if (filters.endDate) params.append('endDate', filters.endDate);

        const response = await axios.get(`${API_BASE_PURCHASES}/search?${params}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la recherche de paiements:", error);
        throw error;
    }
};

const getAllInstructors = async () => {
    try {
        const response = await axios.get(`${API_BASE_USERS}/instructors`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des instructeurs:", error);
        throw error;
    }
};

const getAllStudents = async () => {
    try {
        const response = await axios.get(`${API_BASE_USERS}/students`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des étudiants:", error);
        throw error;
    }
};

const getUserStats = async () => {
    try {
        const response = await axios.get(`${API_BASE_USERS}/stats`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des statistiques:", error);
        throw error;
    }
};

const toggleUserActivation = async (userId) => {
    try {
        const response = await axios.put(`${API_BASE_USERS}/${userId}/toggle-activation`, null, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors du basculement d'activation:", error);
        throw error;
    }
};

const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`${API_BASE_USERS}/${userId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        throw error;
    }
};

const getAllCategoriesAdmin = async () => {
    try {
        const response = await axios.get(API_BASE_CATEGORIES, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des catégories:", error);
        throw error;
    }
};

const createCategory = async (categoryData) => {
    try {
        const response = await axios.post(API_BASE_CATEGORIES, categoryData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création de la catégorie:", error);
        throw error;
    }
};

const updateCategory = async (id, categoryData) => {
    try {
        const response = await axios.put(`${API_BASE_CATEGORIES}/${id}`, categoryData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la catégorie:", error);
        throw error;
    }
};

const deleteCategory = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_CATEGORIES}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression de la catégorie:", error);
        throw error;
    }
};

const getCategoriesStats = async () => {
    try {
        const response = await axios.get(`${API_BASE_CATEGORIES}/stats`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des stats:", error);
        throw error;
    }
};

const getSubcategoriesByCategory = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_SUBCATEGORIES}/category/${categoryId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des sous-catégories:", error);
        throw error;
    }
};

const createSubCategory = async (categoryId, subCategoryData) => {
    try {
        const response = await axios.post(
            `${API_BASE_SUBCATEGORIES}/category/${categoryId}`,
            subCategoryData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création de la sous-catégorie:", error);
        throw error;
    }
};

const updateSubCategory = async (id, subCategoryData) => {
    try {
        const response = await axios.put(
            `${API_BASE_SUBCATEGORIES}/${id}`,
            subCategoryData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la sous-catégorie:", error);
        throw error;
    }
};

const deleteSubCategory = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_SUBCATEGORIES}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression de la sous-catégorie:", error);
        throw error;
    }
};

const getAllPlanPurchases = async () => {
    const response = await axios.get(`${API_BASE}/admin/plan-purchases`, {
        headers: authHeader(),
    });
    return response.data;
};

const getPlanPurchaseStats = async () => {
    const response = await axios.get(`${API_BASE}/admin/plan-purchases/stats`, {
        headers: authHeader(),
    });
    return response.data;
};

const activatePlanPurchase = async (purchaseId) => {
    const response = await axios.post(
        `${API_BASE}/admin/plan-purchases/${purchaseId}/activate`,
        null,
        { headers: authHeader() }
    );
    return response.data;
};

const deactivatePlanPurchase = async (purchaseId) => {
    const response = await axios.post(
        `${API_BASE}/admin/plan-purchases/${purchaseId}/deactivate`,
        null,
        { headers: authHeader() }
    );
    return response.data;
};

const resendPlanAccessEmail = async (purchaseId) => {
    const response = await axios.post(
        `${API_BASE}/admin/plan-purchases/${purchaseId}/resend-email`,
        null,
        { headers: authHeader() }
    );
    return response.data;
};

// ========================================
// MÉTHODES POUR LES NOTIFICATIONS (API SEULEMENT)
// ========================================

const getMyNotifications = async () => {
    try {
        const response = await axios.get(`${API_BASE}/notifications`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des notifications :", error);
        throw error;
    }
};

const getUnreadNotifications = async () => {
    try {
        const response = await axios.get(`${API_BASE}/notifications/unread`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des notifications non lues :", error);
        throw error;
    }
};

const getUnreadNotificationsCount = async () => {
    try {
        const response = await axios.get(`${API_BASE}/notifications/unread/count`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du comptage des notifications :", error);
        throw error;
    }
};

const getNotificationsWithPagination = async (page = 0, size = 10) => {
    try {
        const response = await axios.get(`${API_BASE}/notifications/paginated`, {
            params: { page, size },
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des notifications paginées :", error);
        throw error;
    }
};

const markNotificationAsRead = async (notificationId) => {
    try {
        const response = await axios.put(
            `${API_BASE}/notifications/${notificationId}/read`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du marquage de la notification :", error);
        throw error;
    }
};

const markAllNotificationsAsRead = async () => {
    try {
        const response = await axios.put(
            `${API_BASE}/notifications/mark-all-read`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du marquage de toutes les notifications :", error);
        throw error;
    }
};

const createNotification = async (notificationData) => {
    try {
        const response = await axios.post(
            `${API_BASE}/notifications/create`,
            notificationData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la création de la notification :", error);
        throw error;
    }
};

const getNotificationStats = async () => {
    try {
        const response = await axios.get(`${API_BASE}/notifications/stats`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des statistiques :", error);
        throw error;
    }
};

const createTestNotification = async () => {
    try {
        const response = await axios.post(
            `${API_BASE}/notifications/test`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la création de la notification de test :", error);
        throw error;
    }
};

const cleanupOldNotifications = async (daysToKeep = 30) => {
    try {
        const response = await axios.post(
            `${API_BASE}/notifications/cleanup`,
            null,
            {
                params: { daysToKeep },
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du nettoyage des notifications :", error);
        throw error;
    }
};

// ========================================
// SUPPRESSION LOGIQUE DES COURS
// ========================================

const softDeleteCourse = async (courseId) => {
    try {
        const response = await fetch(`${API_BASE}/courses/${courseId}`, {
            method: "DELETE",
            headers: {
                ...authHeader(),
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.text();
            throw new Error(errorData || `Erreur HTTP: ${response.status}`);
        }

        return await response.text();
    } catch (error) {
        console.error("Erreur lors de la suppression logique:", error);
        throw error;
    }
};

const restoreCourse = async (courseId) => {
    try {
        const response = await fetch(`${API_BASE}/courses/${courseId}/restore`, {
            method: "PUT",
            headers: {
                ...authHeader(),
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.text();
            throw new Error(errorData || `Erreur HTTP: ${response.status}`);
        }

        return await response.text();
    } catch (error) {
        console.error("Erreur lors de la restauration:", error);
        throw error;
    }
};

const getDeletedCourses = async () => {
    try {
        const response = await fetch(`${API_BASE}/courses/deleted`, {
            method: "GET",
            headers: authHeader(),
        });

        if (!response.ok) {
            throw new Error(`Erreur HTTP: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Erreur lors de la récupération des cours supprimés:", error);
        throw error;
    }
};


// Dans course.service.js, ajoutez ces méthodes si elles n'existent pas :

const permanentlyDeleteCourse = async (courseId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}${courseId}/permanent`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur suppression définitive:", error);
        throw error;
    }
};




// 🚀 NOUVELLE MÉTHODE : Récupérer les infos de base du cours (ultra-rapide)
// const getCourseBasic = async (courseId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL_COURSES}${courseId}/basic`, {
//             headers: authHeader(),
//         });
//         console.log("🚀 Infos de base récupérées rapidement:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur lors de la récupération des infos de base :", error);
//         throw error;
//     }
// };

const getCourseBasic = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}${courseId}/basic`, {
            headers: authHeader(),
        });
        console.log("🚀 Infos de base récupérées rapidement:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des infos de base :", error);
        throw error;
    }
};

const getSubjectsWithDetails = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/subjects-with-details`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur chargement optimisé:", error);
        throw error;
    }
};






// ========================================
// 🆕 MÉTHODES POUR DRAG_DROP_ZONES
// ========================================

const getZonesByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/zones`, {
            headers: authHeader(),
        });
        console.log("📦 Zones récupérées:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des zones :", error);
        throw error;
    }
};

const getPropositionsByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/propositions`, {
            headers: authHeader(),
        });
        console.log("📦 Propositions récupérées:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des propositions :", error);
        throw error;
    }
};

const addZoneToQuestion = async (questionId, zoneData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/questions/${questionId}/zones`,
            zoneData,
            { headers: authHeader() }
        );
        console.log("✅ Zone ajoutée:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de l'ajout de la zone :", error);
        throw error;
    }
};

const addPropositionToQuestion = async (questionId, propositionData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/questions/${questionId}/propositions`,
            propositionData,
            { headers: authHeader() }
        );
        console.log("✅ Proposition ajoutée:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de l'ajout de la proposition :", error);
        throw error;
    }
};

const deleteZone = async (zoneId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}quizzes/zones/${zoneId}`, {
            headers: authHeader(),
        });
        console.log("🗑️ Zone supprimée");
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression de la zone :", error);
        throw error;
    }
};

const deleteProposition = async (propositionId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}quizzes/propositions/${propositionId}`, {
            headers: authHeader(),
        });
        console.log("🗑️ Proposition supprimée");
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression de la proposition :", error);
        throw error;
    }
};

// ========================================
// 🆕 MÉTHODES POUR DRAG_DROP_IMAGE
// ========================================

const getImageZonesByQuestion = async (questionId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}quizzes/questions/${questionId}/image-zones`,
            { headers: authHeader() }
        );
        console.log("📦 Zones image récupérées:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération des zones image :", error);
        throw error;
    }
};

const addImageZoneToQuestion = async (questionId, zoneData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/questions/${questionId}/image-zones`,
            zoneData,
            { headers: authHeader() }
        );
        console.log("✅ Zone image ajoutée:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de l'ajout de la zone image :", error);
        throw error;
    }
};

const deleteImageZone = async (zoneId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}quizzes/image-zones/${zoneId}`,
            { headers: authHeader() }
        );
        console.log("🗑️ Zone image supprimée");
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la suppression de la zone image :", error);
        throw error;
    }
};

// const updateQuestionImage = async (questionId, imageUrl) => {
//     try {
//         const response = await axios.put(
//             `${API_BASE_URL}quizzes/questions/${questionId}`,
//             { imageUrl },
//             { headers: authHeader() }
//         );
//         console.log("✅ Image de la question mise à jour");
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur lors de la mise à jour de l'image :", error);
//         throw error;
//     }
// };

const updateQuestionImage = async (questionId, imageUrl) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/image`,  // ✅ AJOUTÉ /image
            { imageUrl },
            { headers: authHeader() }
        );
        console.log("✅ Image de la question mise à jour");
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de l'image :", error);
        throw error;
    }
};

// 📄 Récupérer le contenu d'un sujet spécifique
// const getSubjectContent = async  (subjectId) =>{
//     return axios.get(`${API_BASE_URL}subjects/${subjectId}/content`, {
//         headers: authHeader()
//     }).then(response => response.data);
// }

// 🚀 API OPTIMISÉE pour les contrôles de connaissances
const getControlesSummary = async (courseId) => {
    try {
        console.log("⚡ Chargement optimisé des contrôles pour cours:", courseId);
        const response = await axios.get(
            `${API_BASE_URL}quizzes/courses/${courseId}/controles-summary`,
            { headers: authHeader() }
        );
        console.log("✅ Contrôles chargés:", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération contrôles:", error);
        throw error;
    }
};

// 🚀 API OPTIMISÉE pour les évaluations
const getEvaluationsSummary = async (courseId) => {
    try {
        console.log("⚡ Chargement optimisé des évaluations pour cours:", courseId);
        const response = await axios.get(
            `${API_BASE_URL}quizzes/courses/${courseId}/evaluations-summary`,
            { headers: authHeader() }
        );
        console.log("✅ Évaluations chargées:", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération évaluations:", error);
        throw error;
    }
};

// =====================================================
// ✅ AJOUTER CES 2 MÉTHODES dans course.service.js
// =====================================================

// ✅ NOUVEAU : Récupérer le dernier template applicable pour un cours
const getLastTemplate = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_CERTIFICATS}last-template/${courseId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur récupération template:", error.response || error.message);
        return null;
    }
};

// ✅ NOUVEAU : Upload certificat avec option globalTemplate
const uploadImageCertificatWithGlobal = async (file, courseId, formateur, editorContent, settings, globalTemplate) => {
    if (!file) throw new Error("Aucune image fournie.");
    if (!courseId) throw new Error("CourseId manquant.");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseId", courseId);
    formData.append("formateur", formateur);
    formData.append("template_html", editorContent || "");
    formData.append("template_settings", JSON.stringify(settings || {}));
    formData.append("globalTemplate", globalTemplate ? "true" : "false"); // ✅ NOUVEAU

    if (settings?.threshold !== undefined) {
        formData.append("threshold", settings.threshold);
    }

    try {
        const response = await axios.post(
            API_BASE_URL_CERTIFICATS + "upload",
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("✅ Réponse:", response.data);
        return response.data?.url || null;
    } catch (error) {
        console.error("Erreur upload certificat:", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur upload certificat.");
    }
};

const getSubjectsLight = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/subjects/light`, {
            headers: authHeader()
        });
        return response.data || [];
    } catch (error) {
        if (error.response?.status === 204) return []; // No content
        console.error("Erreur lors de la récupération légère des sujets :", error);
        throw error;
    }
};
const getQuizzesBySubjectLight = async (subjectId) => {
    const response = await axios.get(
        `${API_BASE_URL}quizzes/subject/${subjectId}/light`,
        { headers: authHeader() }
    );
    return response.data;
};

const getCourseStructureLight = async (courseId) => {
    const response = await axios.get(`${API_BASE_URL}${courseId}/structure-light`, {
        headers: authHeader(),
    });
    return response.data;
};
const getSubjectContent = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}subjects/${subjectId}/content`, {
        headers: authHeader(),
    });
    return response.data.content;
};

const getQuestionsWithAnswers = async (quizId) => {
    const response = await axios.get(`${API_BASE_URL}quizzes/${quizId}/questions-with-answers`, {
        headers: authHeader(),
    });
    return response.data;
};
const getQuizByIdWithIntro = async (quizId) => {
    const response = await axios.get(`${API_BASE_URL}quizzes/${quizId}/light`, {
        headers: authHeader(),
    });
    return response.data;
};

const getQuestionImageData = async (questionId) => {
    const response = await axios.get(
        `${API_BASE_URL}quizzes/questions/${questionId}/image-data`,
        { headers: authHeader() }
    );
    return response.data;
};

const getLatestPlans = async (limit = 5) => {
    const response = await axios.get(
        `${RESOURCE}/latest?limit=${limit}`,   // RESOURCE = ${API_BASE}/plans
        { headers: authHeader() }
    );
    return response.data;
};

const updateResource = async (resourceId, resourceData) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}resources/${resourceId}`,
            resourceData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur modification ressource:", error);
        throw error;
    }
};

const deleteResource = async (resourceId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}resources/${resourceId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur suppression ressource:", error);
        throw error;
    }
};
const getResourcesBySubject = async (subjectId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}subjects/${subjectId}/resources`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur chargement ressources du sujet:", error);
        throw error;
    }
};

const deleteAttachment = async (attachmentId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}attachments/${attachmentId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur suppression pièce jointe:", error);
        throw error;
    }
};

const updateAttachment = async (attachmentId, fileName) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}attachments/${attachmentId}`,
            { fileName },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur modification pièce jointe:", error);
        throw error;
    }
};

// ✅ NOUVEAU : Toggle visibilité d'un plan
const togglePlanDisplayed = async (planId) => {
    const { data } = await axios.put(
        `${RESOURCE}/${planId}/toggle-displayed`,
        null,
        { headers: authHeader() }
    );
    return data;
};

// ✅ NOUVEAU : Récupérer seulement les plans affichés (pour l'interface publique)
const getDisplayedPlans = async () => {
    const { data } = await axios.get(`${RESOURCE}/displayed`, {
        headers: authHeader(),
        withCredentials: true
    });
    return data;
};

// ✅ Masquer TOUS les plans d'un coup
const hideAllPlans = async () => {
    const { data } = await axios.put(
        `${RESOURCE}/hide-all`,
        null,
        { headers: authHeader() }
    );
    return data;
};

// ✅ Afficher SEULEMENT les plans dont les IDs sont fournis
const setDisplayedPlans = async (ids) => {
    const { data } = await axios.put(
        `${RESOURCE}/set-displayed`,
        { ids },
        { headers: authHeader() }
    );
    return data;
};
const getTrainingsLight = async (courseId) => {
    const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}${courseId}/trainings-light`, {
        headers: authHeader(),
    });
    return response.data;
};
// ✅ Badge template - Sauvegarder
const uploadBadgeTemplate = async (file, courseId, formateur, editorContent, settings) => {
    if (!file) throw new Error("Aucune image fournie.");
    if (!courseId) throw new Error("CourseId manquant.");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseId", courseId);
    formData.append("formateur", formateur);
    formData.append("template_html", editorContent || "");
    formData.append("template_settings", JSON.stringify(settings || {}));

    if (settings?.threshold !== undefined) {
        formData.append("threshold", String(settings.threshold));
    }

    try {
        const response = await axios.post(
            API_BASE_URL_Badges + "upload-template",
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data?.url || null;
    } catch (error) {
        console.error("Erreur upload badge template:", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur upload badge template.");
    }
};

// ✅ Badge template - Récupérer le dernier
const getLastBadgeTemplate = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_Badges}last-template/${courseId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur récupération badge template:", error.response || error.message);
        return null;
    }
};
// ✅ NOUVEAU : Vérifier un badge via QR code (endpoint public, sans auth)
const verifyBadge = async (code) => {
    const response = await axios.get(`${API_BASE_URL_Badges}verify/${code}`);
    return response.data;
};

// // ✅ NOUVEAU : Récupérer le code de vérification d'un badge existant
const getBadgeVerificationCode = async (student, courseId) => {
    const response = await axios.get(`${API_BASE_URL_Badges}verification-code`, {
        params: { student, courseId },
        headers: authHeader(),
    });
    return response.data.verificationCode;
};

// // ✅ Vérifier un badge via QR code (endpoint public, sans auth)
// const verifyBadge = async (code) => {
//     const response = await axios.get(`${API_BASE_URL_Badges}verify/${code}`);
//     return response.data;
// };
 
// // ✅ Récupérer le code de vérification d'un badge existant
// const getBadgeVerificationCode = async (student, courseId) => {
//     const response = await axios.get(`${API_BASE_URL_Badges}verification-code`, {
//         params: { student, courseId },
//         headers: authHeader(),
//     });
//     return response.data.verificationCode;
// };
 
// ✅ NOUVEAU : Bouton "Vérifier mon badge" côté étudiant
// Vérifie la note, génère le badge si OK, envoie l'email
const checkAndGenerateBadge = async (courseId, userId) => {
    const response = await axios.post(
        `${API_BASE_URL_Badges}check-and-generate`,
        null,
        {
            params: { courseId, userId },
            headers: authHeader(),
        }
    );
    return response.data;
};

// ✅ NOUVEAU : Envoyer le badge existant par email
const sendBadgeToEmail = async (courseId, userId) => {
    const response = await axios.post(
        `${API_BASE_URL_Badges}send-to-email`,
        null,
        {
            params: { courseId, userId },
            headers: authHeader(),
        }
    );
    return response.data;
};
const unapproveCourse = async (courseId) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}unapprove/${courseId}`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors du masquage du cours:", error);
        throw error;
    }
};


// const previewCertificat = async (courseId, userId, customName) => {
//     try {
//         console.log("🟢 previewCertificat appelé avec :", { courseId, userId, customName });
//         const params = { courseId, userId };
//         if (customName && String(customName).trim()) {
//             params.customName = String(customName).trim();
//         }
//         const response = await axios.get(
//             `${API_BASE_URL_CERTIFICATS}preview`,
//             {
//                 headers: authHeader(),
//                 params,
//             }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur aperçu certificat:", error.response || error.message);
//         throw new Error(
//             error.response?.data?.message || "Impossible de générer l'aperçu du certificat."
//         );
//     }
// };
 const previewCertificat = async (courseId, userId, customName, customUserName) => {
    try {
        console.log("🟢 previewCertificat appelé avec :", { courseId, userId, customName, customUserName });
        const params = { courseId, userId };
        if (customName && String(customName).trim()) {
            params.customName = String(customName).trim();
        }
        // ✅ NOUVEAU : nom personnalisé de l'utilisateur
        if (customUserName && String(customUserName).trim()) {
            params.customUserName = String(customUserName).trim();
        }
        const response = await axios.get(
            `${API_BASE_URL_CERTIFICATS}preview`,
            {
                headers: authHeader(),
                params,
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur aperçu certificat:", error.response || error.message);
        throw new Error(
            error.response?.data?.message || "Impossible de générer l'aperçu du certificat."
        );
    }
};
const sendManualCertificat = (courseId, userId, targetEmail, customName, customUserName) => {
  let url =
    `${API_BASE}/certificats/send-manual` +
    `?courseId=${courseId}` +
    `&userId=${userId}` +
    `&targetEmail=${encodeURIComponent(targetEmail)}`;
  if (customName && customName.trim()) {
    url += `&customName=${encodeURIComponent(customName.trim())}`;
  }
  // ✅ NOUVEAU : nom personnalisé de l'utilisateur
  if (customUserName && customUserName.trim()) {
    url += `&customUserName=${encodeURIComponent(customUserName.trim())}`;
  }
  return axios
    .post(url, null, { headers: authHeader() })
    .then((res) => res.data);
};
// const sendManualCertificat = (courseId, userId, targetEmail, customName) => {
//   let url =
//     `${API_BASE}/certificats/send-manual` +
//     `?courseId=${courseId}` +
//     `&userId=${userId}` +
//     `&targetEmail=${encodeURIComponent(targetEmail)}`;
//   if (customName && customName.trim()) {
//     url += `&customName=${encodeURIComponent(customName.trim())}`;
//   }
//   return axios
//     .post(url, null, { headers: authHeader() })
//     .then((res) => res.data);
// };
 
 
// ✅ Réinitialiser l'envoi (réutilise l'endpoint existant reset-sent)
const resetSentCertificat = async (courseId, userId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL_CERTIFICATS}reset-sent/${courseId}/${userId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur réinitialisation:", error.response || error.message);
        throw new Error(
            error.response?.data?.message || "Impossible de réinitialiser l'envoi."
        );
    }
};

const getAllUsersDetails = async () => {
    try {
        const response = await axios.get(`${API_BASE}/auth/users-details`, {
            headers: authHeader(),
        });
        return response.data; // [{ id, username, email }, ...]
    } catch (error) {
        console.error("Erreur récupération users-details:", error.response || error.message);
        throw new Error(
            error.response?.data?.message || "Impossible de charger la liste des utilisateurs."
        );
    }
};

const courseService = {
    getAllCourses,
    uploadImage,
    createCourse,
    getCoursesByModerator,
    addSubjectToCourse,
    getSubjectsByCourse,
    getCourseDetails,
    getUserPurchases,
    getCategories,
    getSubcategories,
    addComment,
    updateCourse,
    updateSubject,
    deleteSubject,
    getQuizzesBySubject,
    submitQuizAnswers,
    getQuestionsByQuiz,
    addQuizToSubject,
    deleteQuiz,
    addQuizWithQuestions,
    addQuestionToQuiz,
    addAnswerToQuestion,
    getAnswersByQuestion,
    updateQuestionExplanation,
    getQuestionById,
    updateQuestion,
    updateAnswer,
    deleteQuestion,
    deleteAnswer,
    deleteCourse,
    updateQuiz,
    updateQuizProgress,
    updateCorrectAnswers,
    updateAnswersOrder,
    uploadAttachmentToCourse,
    getAttachmentsByCourse,
    addResourceToCourse,
    getResourcesByCourse,
    getQuizzesByCourse,
    addQuizToCourse,
    uploadAttachmentToSubject,
    addResourceToSubject,
    getAttachmentsBySubject,
    getResourcesBySubject,
    uploadTrainingExercise,
    getTrainingExercisesByCourse,
    updateTrainingGrade,
    deleteTrainingExercise,
    updateExercise,
    getTrainingsByCourse,
    uploadStudentTrainingResponse,
    getQuizById,
    getMatchingPairsByQuestion,
    addMatchingPairToQuestion,
    getSubjectById,
    generateBadge,
    getThreshold,
    updateThreshold,
    getBadgeUrl,
    getAllUsernames,
    getBadgesByCourse,
    deleteBadge,
    getCourseStructure,
    getquizzes_of_cours,
    uploadTrainingExerciseWithPositioning,
    getCourseElements,
    Getgroupnames,
    deleteTrainingBloc,
    updateTrainingExerciseWithPositioning,
    addEvaluationToCourse,
    getEvaluationByCourse,
    submitQuizResult,
    getQuizReviewResults,
    getTrainingExercisesByCourseByUser,
    getTrainingExercisesByCourseByTriningId,
    getTrainingExercisesByCourseByTriningIdAndUserId,
    CalculeNoteFinale,
    CalculePrgresseByType,
    getAttemptOnceByCourse,
    GetNotAttemptedItems,
    uploadImageCertificat,
    getGeneratedCertificat,
    getLastThresholdCertificat,
    getLastThresholdbadge,
    getTotalPourcentage,

    // Méthodes de paiement
    createPaymentIntent,
    getPaymentStatus,
    getMyPurchases,
    getMyPurchases2,
    checkCourseOwnership,
    getCourseById,
    getCoursesByUserId,
    confirmPayment,
    createPaymentIntentLegacy,
    createPayPalPayment,
    executePayPalPayment,
    createMonerisTicket,
    monerisVerifyTicket,

    // Plans
    getAllPlans,
    getPlanById,
    createPlan,
    updatePlan,
    deletePlan,
    createSalesRequest,

    // Cours optimisés
    getCourseSummary,
    getCoursesByCategory,
    getCoursesWithPagination,

    // Actualités
    getAllNews,
    getLatestNews,
    getNewsById,
    createNews,
    updateNews,
    deleteNews,

    // Sales Requests
    getSalesRequests,
    updateSalesRequestStatus,
    updateSalesRequest,
    deleteSalesRequest,
    getSalesRequestById,

    // Demandes d'instructeur
    createInstructorRequest,
    getAllInstructorRequests,
    getInstructorRequestsWithPagination,
    getInstructorRequestsByStatus,
    getInstructorRequestById,
    updateInstructorStatus,
    updateInstructorStatusWithNotes,
    deleteInstructorRequest,
    searchInstructorByEmail,
    searchInstructorBySubject,
    searchInstructorByName,
    advancedInstructorSearch,
    getInstructorStats,
    getRecentInstructorRequests,
    getOverdueInstructorRequests,
    getAvailableInstructorStatuses,

    // Cours admin
    getAllCoursesOptimized,
    getAllCoursesForAdmin,
    getPendingCourses,
    approveCourse,
    rejectCourse,
    verifyAndProcessMonerisPayment,
    getAllPurchases,
    getPurchaseStats,
    searchPurchases,

    // Utilisateurs
    getAllInstructors,
    getAllStudents,
    getUserStats,
    toggleUserActivation,
    deleteUser,

    // Catégories
    getAllCategoriesAdmin,
    createCategory,
    updateCategory,
    deleteCategory,
    getCategoriesStats,
    getSubcategoriesByCategory,
    createSubCategory,
    updateSubCategory,
    deleteSubCategory,

    // Plans purchases
    getAllPlanPurchases,
    getPlanPurchaseStats,
    activatePlanPurchase,
    deactivatePlanPurchase,
    resendPlanAccessEmail,

    // Notifications (méthodes API seulement - PAS le hook)
    getMyNotifications,
    getUnreadNotifications,
    getUnreadNotificationsCount,
    getNotificationsWithPagination,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    createNotification,
    getNotificationStats,
    createTestNotification,
    cleanupOldNotifications,

    // Suppression logique
    softDeleteCourse,
    restoreCourse,
    getDeletedCourses, permanentlyDeleteCourse,
    getQuizByIdWithIntro,

    getCourseBasic,
    getSubjectsWithDetails,


    // ✅ AJOUTER CES 6 LIGNES ICI :
    getZonesByQuestion,
    getPropositionsByQuestion,
    addZoneToQuestion,
    addPropositionToQuestion,
    deleteZone,
    deleteProposition,

    // 🆕 AJOUTER CES 4 NOUVELLES LIGNES :
    getImageZonesByQuestion,
    addImageZoneToQuestion,
    deleteImageZone,
    updateQuestionImage,
    getSubjectContent,


    getControlesSummary,      // 🆕 AJOUTER
    getEvaluationsSummary,    // 🆕 AJOUTER


    getLastTemplate,
    uploadImageCertificatWithGlobal,

    getSubjectsLight,
    getQuizzesBySubjectLight, getCourseStructureLight,
    getQuestionsWithAnswers, getQuizByIdWithIntro,
    getQuestionImageData, getLatestPlans,
    deleteResource, updateResource,
    deleteAttachment,
    updateAttachment,

    // Plans (NOUVEAU)
    togglePlanDisplayed,
    getDisplayedPlans,

    hideAllPlans,
    setDisplayedPlans,

    getTrainingsLight,

    uploadBadgeTemplate, getLastBadgeTemplate,
    verifyBadge,getBadgeVerificationCode,checkAndGenerateBadge 
,sendBadgeToEmail,

unapproveCourse,


   previewCertificat,
   sendManualCertificat,
   resetSentCertificat,

   getAllUsersDetails,

};

export default courseService;